import React from 'react';
import './styles.css';

const MobileEducation = ({ isDarkMode }) => {
    const educationData = [
        {
            title: "B.Tech + MS in CSE by Research",
            period: "2023 - 2028",
            institution: "International Institute of Information Technology (IIIT), Hyderabad",
            description: "Currently in my fourth year with 8.5 CGPA. Research focus on Software Engineering under the guidance of Prof. Karthik Vaidhyanathan at SERC."
        },
        {
            title: "Class XII - CBSE",
            period: "2021 - 2023",
            institution: "The Mother's International School, Delhi",
            description: "Achieved 92.6% and was part of the school's tech club, MINET. As a programming team lead helped organise and participated (and won) in various tech events."
        },
        {
            title: "Class X - CBSE",
            period: "2009 - 2021",
            institution: "Ramjas International School, Delhi",
            description: "Scored 93.3%. As part of the Atal Innovation Mission, built and worked on many real-world solutions and product prototypes; receiving various awards and national-level recognition."
        }
    ];

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Education</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {educationData.map((edu, index) => (
                        <div key={index} className="mobile-card">
                            <div className="mobile-card-header">
                                <h3 className="mobile-card-title">{edu.title}</h3>
                                <p className="mobile-card-period">{edu.period}</p>
                            </div>
                            <p className="mobile-card-subtitle">{edu.institution}</p>
                            <p className="mobile-card-description">{edu.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileEducation;
